export default __webpack_public_path__ + "static/media/farm-SYMM-FRACTION.3d4f1e4a.svg";